var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRatingStarFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2855 15.852C13.2384 16.3534 14.1593 15.6858 13.9771 14.6227L13.2926 10.6378C13.2997 10.6769 16.1788 7.84671 16.1788 7.84671C16.9504 7.09471 16.5993 6.01294 15.5326 5.85738L11.5308 5.27605C11.57 5.28227 9.76818 1.66982 9.76818 1.66982C9.29084 0.703602 8.15395 0.702713 7.67662 1.66982L5.88729 5.2956C5.90507 5.26005 1.91218 5.85738 1.91218 5.85738C0.845509 6.01294 0.494398 7.09294 1.26595 7.84671L4.16106 10.6689C4.13351 10.6414 3.46773 14.6227 3.46773 14.6227C3.28551 15.6849 4.20551 16.3543 5.15929 15.852L8.73884 13.9703C8.70329 13.9889 12.2855 15.852 12.2855 15.852Z",
    fill: "#FFD91F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingStarFilled);
export default __webpack_public_path__ + "static/media/RatingStarFilled.0721d02ee5cf853efe13dc3a6accedec.svg";
export { ForwardRef as ReactComponent };